"use client"

import { useState, useEffect } from "react"
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  IconButton,
  Grid,
  Autocomplete,
  CircularProgress,
  InputAdornment,
  Snackbar,
  Alert as MuiAlert,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import AddIcon from "@mui/icons-material/Add"
import DeleteIcon from "@mui/icons-material/Delete"
import axios from "axios"
import BaseURL from "../../api/AppURL";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "98%", sm: "95%", md: "85%", lg: "75%" },
  maxWidth: 1200,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  maxHeight: "95vh",
  overflowY: "auto",
}

export default function AddPaymentModal({ open, onClose, onSaveSuccess }) {
  const [paymentMode, setPaymentMode] = useState("")
  const [customers, setCustomers] = useState([])
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [loadingCustomers, setLoadingCustomers] = useState(false)
  const [loadingProducts, setLoadingProducts] = useState(false)
  const [formData, setFormData] = useState({
    mobile_no: "",
    address: "",
    amount: "",
    dueamount: "",
    dueafterpay: "",
  })
  const [paymentDate, setPaymentDate] = useState("")
  const [amount, setAmount] = useState("")
  const [comment, setComment] = useState("")
  const [netAmount, setNetAmount] = useState("")
  const [productRows, setProductRows] = useState([])
  const [totalSum, setTotalSum] = useState(0)
  // Snackbar states
  const [alertOpen, setAlertOpen] = useState(false)
  const [alertMsg, setAlertMsg] = useState("")
  const [alertType, setAlertType] = useState("error")
  const [storeClicked, setStoreClicked] = useState(false)

  // Extra payment mode States
  const [bankAccounts, setBankAccounts] = useState([])
  const [selectedBankAccount, setSelectedBankAccount] = useState(null)
  const [checkNumber, setCheckNumber] = useState("")
  const [senderMobileNo, setSenderMobileNo] = useState("")
  const [transactionId, setTransactionId] = useState("")
  const [expenses, setExpenses] = useState([])
  const [selectedExpense, setSelectedExpense] = useState(null)
  const [trCharge, setTrCharge] = useState("")

  useEffect(() => {
    if (open) {
      fetchData()
      // fetchBankAccounts()
      // fetchExpenses()
      // resetForm()
      // Optionally resetForm() on modal open
    }
    // eslint-disable-next-line
  }, [open])





  // Net Amount, Due After Payment & Charge Calculation
  useEffect(() => {
    let due = Number(formData.dueamount) || 0
    let amt = Number(amount) || 0
    let tr = Number(trCharge) || 0
    let net = amt

    // Charge Calculation
    if (paymentMode === "Bkash") net = amt - Math.floor(amt / 500) * 9
    else if (paymentMode === "Nagad") net = amt - Math.floor(amt / 500) * 8
    else if (paymentMode === "Rocket") net = amt - Math.floor(amt / 500) * 7
    else if (paymentMode === "Upay") net = amt - Math.floor(amt / 500) * 6
    else if (paymentMode === "BankTR") net = amt - tr

    setNetAmount(net > 0 ? net : "")
    setFormData(prev => ({
      ...prev,
      dueafterpay: due - amt > 0 ? due - amt : "",
    }))
  }, [amount, paymentMode, trCharge, formData.dueamount])

  useEffect(() => {
    if (
      ["Bkash", "Nagad", "Rocket", "Upay", "BankTR"].includes(paymentMode) &&
      expenses.length > 0
    ) {
      // নাম মিলিয়ে ফিল্টার (case insensitive)
      const found = expenses.find(
        exp =>
          exp.edetailsname &&
          exp.edetailsname.toLowerCase().includes(paymentMode.toLowerCase())
      );
      setSelectedExpense(found || null);
    }
  }, [paymentMode, expenses]);


  function parseDueAmount(val) {
    if (typeof val === "string" && val.endsWith("cr")) {
      // "500cr" -> -500
      return -Number(val.replace("cr", ""));
    }
    return Number(val) || 0;
  }


  function formatDueAfterPayment(due, amount) {
    const dueNum = parseDueAmount(due);
    const amtNum = Number(amount) || 0;
    const result = dueNum - amtNum;
    if (amtNum === 0) return ""; // Amount না লিখলে কিছু না দেখাও
    if (result < 0) return `${Math.abs(result)}cr`;
    if (result > 0) return result;
    return 0;
  }

  const formatDueAmount = (value) => {
    // ফাঁকা/null হলে কিছুই দেখাবে না
    if (value === undefined || value === null || value === "") return "";
    const num = Number(value);
    if (isNaN(num)) return "";
    if (num < 0) return `${Math.abs(num)}cr`;
    return num;
  };
  
  const resetForm = () => {
    setSelectedCustomer(null)
    setSelectedProduct(null)
    setFormData({ mobile_no: "", address: "", amount: "", dueamount: "", dueafterpay: "" })
    setPaymentDate("")
    setAmount("")
    setComment("")
    setNetAmount("")
    setProductRows([])
    setTotalSum(0)
    setAlertMsg("")
    setStoreClicked(false)
    setPaymentMode("")

    setSelectedBankAccount(null)
    setCheckNumber("")
    setSenderMobileNo("")
    setTransactionId("")
    setSelectedExpense(null)
    setTrCharge("")
  }

  const fetchData = async () => {
    setLoadingCustomers(true)
    setLoadingProducts(true)
    try {
      const token = localStorage.getItem("auth_token")
      const response = await axios.get(`${BaseURL}/payment/add`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      setCustomers(response.data.customers || [])
      setBankAccounts(response.data.bankaccounts || [])
      setExpenses(response.data.expensetype || [])

    } catch (err) {
      console.error("Error fetching data:", err)
    } finally {
      setLoadingCustomers(false)
      setLoadingProducts(false)
    }
  }


  const handleCustomerChange = async (event, newValue) => {
    setSelectedCustomer(newValue)
    if (newValue) {
      try {
        const token = localStorage.getItem("auth_token")
        const response = await axios.get(`${BaseURL}/getpay/mobiadd/${newValue.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })

        const { mobile_no, address, total_due } = response.data

        // নতুন enriched প্রোডাক্ট বানাও API এর ডেটা দিয়ে
        const enrichedProduct = {
          ...newValue,
          mobile_no: mobile_no,
          address: address,
          dueamount: total_due,
        }

        setFormData(enrichedProduct)
      } catch (err) {
        console.error("Failed to fetch available quantity:", err)
      }

    }
  }



  // Snackbar alert trigger function
  const showAlert = (msg, type = "error") => {
    setAlertMsg(msg)
    setAlertType(type)
    setAlertOpen(true)
  }

  const handleModalClose = () => {
    onClose()
    // resetForm() 
  }

  // Payment Store validation & submit
  const handlePaymentStore = async () => {
    setStoreClicked(true)

    try {
      const token = localStorage.getItem("auth_token")

      const payload = {
        customer_id: selectedCustomer?.id,
        payment_date: paymentDate,
        payment_mode: paymentMode,
        prev_amount: amount,
        amount: netAmount,
        comment: comment,
      };

      // Payment mode specific fields
      if (paymentMode === "Check") {
        payload.bank_account_number = selectedBankAccount?.id;
        payload.check_number = checkNumber;
      }
      if (paymentMode === "Bkash") {
        payload.bkash_number = senderMobileNo;
        payload.tranx_number = transactionId;
        if (selectedExpense?.id) payload.expense_typeb = selectedExpense.id;
      }
      if (paymentMode === "Nagad") {
        payload.nagad_number = senderMobileNo;
        payload.ntranx_number = transactionId;
        if (selectedExpense?.id) payload.expense_typen = selectedExpense.id;
      }
      if (paymentMode === "Rocket") {
        payload.rocket_number = senderMobileNo;
        payload.rtranx_number = transactionId;
        if (selectedExpense?.id) payload.expense_typer = selectedExpense.id;
      }
      if (paymentMode === "Upay") {
        payload.upay_number = senderMobileNo;
        payload.utranx_number = transactionId;
        if (selectedExpense?.id) payload.expense_typeu = selectedExpense.id;
      }
      if (paymentMode === "BankTR") {
        payload.bank_account_numbertr = selectedBankAccount?.id;
        payload.tr_charge = trCharge;
        if (selectedExpense?.id) payload.expense_typebtr = selectedExpense.id;
      }

      const response = await axios.post(
        `${BaseURL}/payment/store`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      )

      // Success: show parent snackbar, refresh table
      const successMessage = response.data.message || "Payment Saved successfully!"
      if (onSaveSuccess) {
        onSaveSuccess(successMessage)
      }
      resetForm()
      onClose()
    } catch (error) {
      console.error("Failed to save payment:", error)
      const errorMsg = error.response?.data?.message || "Something went wrong while saving."
      showAlert(errorMsg, "error")
    }
  }
  // Payment mode conditional fields
  const renderPaymentModeFields = () => {
    if (paymentMode === "Check") {
      return (
        <>
          <Autocomplete
            options={bankAccounts}
            getOptionLabel={option => option.bank_account || ""}
            value={selectedBankAccount}
            onChange={(e, v) => setSelectedBankAccount(v)}
            renderInput={params => <TextField {...params} label="Bank Receive Account" sx={{ mb: 2 }} />}
          />
          <TextField
            fullWidth
            label="Check Number"
            value={checkNumber}
            onChange={e => setCheckNumber(e.target.value)}
            sx={{ mb: 2 }}
          />
        </>
      )
    }
    if (["Bkash", "Nagad", "Rocket", "Upay"].includes(paymentMode)) {
      let paymentLabel = ""
      if (paymentMode === "Bkash") paymentLabel = "Bkash Sender Mobile No"
      else if (paymentMode === "Nagad") paymentLabel = "Nagad Sender Mobile No"
      else if (paymentMode === "Rocket") paymentLabel = "Rocket Sender Mobile No"
      else if (paymentMode === "Upay") paymentLabel = "Upay Sender Mobile No"

      return (
        <>
          <TextField
            fullWidth
            label={paymentLabel}
            value={senderMobileNo}
            onChange={e => setSenderMobileNo(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Transaction ID"
            value={transactionId}
            onChange={e => setTransactionId(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Autocomplete
            options={expenses}
            getOptionLabel={option => option.edetailsname || ""}
            value={selectedExpense}
            onChange={(e, v) => setSelectedExpense(v)}
            renderInput={params => <TextField {...params} label="Select Expense" sx={{ mb: 2 }} />}
          />
        </>
      )
    }
    if (paymentMode === "BankTR") {
      return (
        <>
          <Autocomplete
            options={bankAccounts}
            getOptionLabel={option => option.bank_account || ""}
            value={selectedBankAccount}
            onChange={(e, v) => setSelectedBankAccount(v)}
            renderInput={params => <TextField {...params} label="Bank Receive Account" sx={{ mb: 2 }} />}
          />
          <Autocomplete
            options={expenses}
            getOptionLabel={option => option.edetailsname || ""}
            value={selectedExpense}
            onChange={(e, v) => setSelectedExpense(v)}
            renderInput={params => <TextField {...params} label="Select Expense" sx={{ mb: 2 }} />}
          />
          <TextField
            fullWidth
            label="TR Charge"
            value={trCharge}
            onChange={e => setTrCharge(e.target.value.replace(/[^0-9.]/g, ""))}
            sx={{ mb: 2 }}
          />
        </>
      )
    }
    return null
  }


  return (
    <>
      <Modal open={open} onClose={handleModalClose}>
        <Box sx={style}>
          {/* Header */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography variant="h5" fontWeight={600}>
              Add Payment
            </Typography>
            <IconButton onClick={handleModalClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Body */}
          <Grid
            container
            spacing={4}
            sx={{
              flexWrap: {
                xs: "wrap",
                md: "nowrap",
              },
              "@media (max-width:1265px) and (min-width:1200px)": {
                flexWrap: "nowrap",
              },
            }}
          >
            {/* Left Column */}
            <Grid item xs={12} md={6}>
              <Autocomplete
                options={customers}
                getOptionLabel={(option) => option.name || ""}
                value={selectedCustomer}
                onChange={handleCustomerChange}
                loading={loadingCustomers}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Customer"
                    sx={{ mb: 2 }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingCustomers ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                noOptionsText={loadingCustomers ? "Loading customers..." : "No customers found"}
              />
              <TextField
                fullWidth
                label="Mobile Number"
                value={formData.mobile_no}
                InputProps={{ readOnly: true }}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Address"
                value={formData.address}
                InputProps={{ readOnly: true }}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Due Amount"
                value={formatDueAmount(formData.dueamount)}
                InputProps={{ readOnly: true }}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Due After Payment"

                value={formatDueAfterPayment(formData.dueamount, amount)}

                InputProps={{ readOnly: true }}
                sx={{ mb: 2 }}
              />

            </Grid>

            {/* Right Column */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Payment Date"
                type="date"
                value={paymentDate}
                onChange={e => setPaymentDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Amount"
                value={amount}
                onChange={e => setAmount(e.target.value)}
                sx={{ mb: 2 }}
              />

              <Box sx={{ mb: 2 }}>
                <Typography sx={{ mb: 1 }}>Payment Mode</Typography>
                <RadioGroup
                  row
                  value={paymentMode}
                  onChange={e => setPaymentMode(e.target.value)}
                >
                  <FormControlLabel value="Cash" control={<Radio />} label="Cash" />
                  <FormControlLabel value="Card" control={<Radio />} label="Card" />
                  <FormControlLabel value="Check" control={<Radio />} label="Check" />
                  <FormControlLabel value="Bkash" control={<Radio />} label="Bkash" />
                  <FormControlLabel value="Nagad" control={<Radio />} label="Nagad" />
                  <FormControlLabel value="Rocket" control={<Radio />} label="Rocket" />
                  <FormControlLabel value="Upay" control={<Radio />} label="Upay" />
                  <FormControlLabel value="BankTR" control={<Radio />} label="Bank TR" />
                </RadioGroup>
              </Box>
              {/* Conditional payment mode fields */}
              {renderPaymentModeFields()}
              <TextField
                fullWidth
                label="Net Amount"
                value={netAmount}
                InputProps={{ readOnly: true }}
                onChange={e => setNetAmount(e.target.value)}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Comment"
                value={comment}
                onChange={e => setComment(e.target.value)}
                sx={{ mb: 2 }}
              />


            </Grid>
          </Grid>



          {/* Footer */}
          <Box sx={{ mt: 2 }}>
            <Button
              variant="contained"
              sx={{
                bgcolor: "#04b6e0",
                color: "white",
                px: 2,
                py: 0.5,
                fontSize: 18,
                fontWeight: 550,
                borderRadius: 1,
                "&:hover": { bgcolor: "#0299be" },
              }}
              onClick={handlePaymentStore}
            >
              Payment Store
            </Button>
          </Box>
        </Box>
      </Modal>
      {/* Snackbar Alert */}
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={() => setAlertOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setAlertOpen(false)}
          severity={alertType}
          elevation={6}
          variant="filled"
          sx={{ fontWeight: 600, fontSize: 16 }}
        >
          {alertMsg}
        </MuiAlert>
      </Snackbar>
    </>
  )
}